export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'a407d28b-e6f6-4a5f-97ee-c422e6b5ff52',
      authority:
        'https://login.microsoftonline.com/fe16105c-2cd4-4447-b05f-440cb233041a',
    },
  },
  apiConfig: {
    uri: 'api://a407d28b-e6f6-4a5f-97ee-c422e6b5ff52/.default',
    scopes: ['api://a407d28b-e6f6-4a5f-97ee-c422e6b5ff52/ContentFiltering'],
  },
  rbacAPIConfig: {
    uri: 'https://rbac.dev.udtsp.net/api',
    scopes: ['api://a407d28b-e6f6-4a5f-97ee-c422e6b5ff52/ContentFiltering'],
  },
  policyManagementAPIConfig: {
    uri: 'https://policy-management.dev.udtsp.net/api',
    scopes: ['api://a407d28b-e6f6-4a5f-97ee-c422e6b5ff52/ContentFiltering'],
    defaultPageSize: 10,
  }
};
